import script from "./MainBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBanner.vue?vue&type=script&setup=true&lang=js"

import "./MainBanner.vue?vue&type=style&index=0&id=cd7ad548&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd7ad548"]])

export default __exports__